import { DATETIME_UNIT } from '@ricoh/ria.client.core/constants/core/unit';

import type { BatchPriority, BatchStage, BatchStatus, PageRotation, ProcessStage } from '~/common/model/api/batch';

/** Batch statuses. */
export const BATCH_STATUSES: BatchStatus[] = [
  'none',
  // New Batch
  'initial',
  'draft',
  'aiSeparating',
  'aiClassifying',
  'aiExtracting',
  'newBatchProcessing',
  'newBatchFailed',
  // Review
  'review',
  'reviewFailed',
  // Validation
  'validation',
  'validationFailed',
  // Confirmation
  'confirmation',
  'confirmationFailed',
  // Approval
  'approval',
  'approvalFailed',
  // Export
  'pendingExport',
  'exportFailed',
  // Exception
  'exception',
  // Completed
  'completed',
  // Error
  'error',
] as const;

/** Process Stage map Batch status. */
export const PROCESS_STAGE_MAP_STATUS: Record<ProcessStage, BatchStatus[]> = {
  new: ['initial', 'draft', 'newBatchProcessing'],
  review: ['review'],
  validation: ['validation'],
  confirmation: ['confirmation'],
} as const;

/** Process Viewable Batch statuses. */
export const PROCESS_VIEWABLE_BATCH_STATUSES = Object.values(PROCESS_STAGE_MAP_STATUS).flat();

/** Batch Stage map Batch status. */
export const BATCH_STAGE_MAP_STATUS: Record<BatchStage, BatchStatus[]> = {
  scan: [],
  import: [],
  newBatch: ['initial', 'draft', 'aiSeparating', 'aiClassifying', 'aiExtracting', 'newBatchProcessing', 'newBatchFailed'],
  review: ['review', 'reviewFailed'],
  validation: ['validation', 'validationFailed'],
  confirmation: ['confirmation', 'confirmationFailed'],
  approval: ['approval', 'approvalFailed'],
  export: ['pendingExport', 'exportFailed'],
  exception: ['exception'],
  completed: ['completed'],
  error: ['error'],
} as const;

/** Batch priorities. */
export const BATCH_PRIORITIES: BatchPriority[] = ['high', 'normal', 'low'] as const;

/** Batch PageSize. */
export const BATCH_PAGE_SIZE = {
  WIDTH: 210,
  HEIGHT: 297,
} as const;

/** Batch PageScale. */
export const BATCH_PAGE_SCALE = {
  DEFAULT: 1.8,
  MINI: 0.075,
  STEP: 0.025,
} as const;

/** Batch rotation. */
export const BATCH_PAGE_ROTATION: Record<PageRotation, number> = {
  noRotation: 0,
  clockwise: -90,
  counterclockwise: 90,
  upsideDown: 180,
} as const;

/** Batch extend locked interval. */
export const BATCH_EXTEND_LOCKED_INTERVAL = 4.5 * DATETIME_UNIT.MINUTE;

/** Batch extend locked timeout. */
export const BATCH_EXTEND_LOCKED_TIMEOUT = 30 * DATETIME_UNIT.SECOND;
